// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.1
//   protoc               v5.27.3
// source: proto/metrics_web.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";

/** Operating system type - prefixed with OS_ to avoid NDK definition conflict. */
export enum OsType {
  UNKNOWN_OS_TYPE = 0,
  OS_IOS = 1,
  OS_ANDROID = 2,
  OS_WEB = 3,
  UNRECOGNIZED = -1,
}

export function osTypeFromJSON(object: any): OsType {
  switch (object) {
    case 0:
    case "UNKNOWN_OS_TYPE":
      return OsType.UNKNOWN_OS_TYPE;
    case 1:
    case "OS_IOS":
      return OsType.OS_IOS;
    case 2:
    case "OS_ANDROID":
      return OsType.OS_ANDROID;
    case 3:
    case "OS_WEB":
      return OsType.OS_WEB;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OsType.UNRECOGNIZED;
  }
}

export function osTypeToJSON(object: OsType): string {
  switch (object) {
    case OsType.UNKNOWN_OS_TYPE:
      return "UNKNOWN_OS_TYPE";
    case OsType.OS_IOS:
      return "OS_IOS";
    case OsType.OS_ANDROID:
      return "OS_ANDROID";
    case OsType.OS_WEB:
      return "OS_WEB";
    case OsType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AppVersion {
  versionNumber:
    | AppVersion_VersionNumber
    | undefined;
  /** build flavor DEBUG, CANARY, ALPHA, MASTER */
  flavor: string;
  /** SNAPSHOT, OG, MUSHROOM see Blizzard Schema's AppVariantType https://snapchat.quip.com/UVHDA0J59IDz */
  variant: string;
}

/** Deconstructed app version values (e.g 10.32.0.41512) */
export interface AppVersion_VersionNumber {
  major: number;
  minor: number;
  patch: number;
  build: number;
}

/** Used to represent multi-value collections - i.e buffers of timers/histograms (levels) */
export interface Metric {
  /** key string (32 bytes max) */
  partitionName: string;
  /** value string (32 bytes max) */
  metricName: string;
  /** max 5 custom dimensions (32 bytes key to 100 byte mapping) */
  customDimensions: { [key: string]: string };
  /**
   * Bound collection of values
   * Units unspecified in transit - this depends on interpretation by the consumer/producer
   * Scalar aggregate outputs i.e will have only 1 value (i.e summed up counter values)
   */
  values: number[];
}

export interface Metric_CustomDimensionsEntry {
  key: string;
  value: string;
}

/** Frames may be flushed abitrarily on the client depending on client buffer size/timing */
export interface MetricFrame {
  timers: Metric[];
  counters: Metric[];
  levels: Metric[];
  /** protocol version of client measure - this is a compile time constant */
  protocolVersion: number;
  /**
   * timestamp of first sampled metric in frame.
   * milliseconds since epoch.
   */
  bufferStartTimestampMillis: number;
  /**
   * timestamp of last sampled metric in frame.
   * milliseconds since epoch.
   */
  bufferEndTimestampMillis: number;
  /** App Version encoded - this value will be the same on all requests from the same client binary */
  appVersion:
    | AppVersion
    | undefined;
  /** Client identifer - this value will be the same on all requests from the same client binary */
  clientOsType: OsType;
  /** User ID - Used for Graphene / Easy AB integration */
  userId: string;
}

function createBaseAppVersion(): AppVersion {
  return { versionNumber: undefined, flavor: "", variant: "" };
}

export const AppVersion = {
  encode(message: AppVersion, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.versionNumber !== undefined) {
      AppVersion_VersionNumber.encode(message.versionNumber, writer.uint32(10).fork()).ldelim();
    }
    if (message.flavor !== "") {
      writer.uint32(18).string(message.flavor);
    }
    if (message.variant !== "") {
      writer.uint32(26).string(message.variant);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AppVersion {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppVersion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.versionNumber = AppVersion_VersionNumber.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.flavor = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.variant = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppVersion {
    return {
      versionNumber: isSet(object.versionNumber) ? AppVersion_VersionNumber.fromJSON(object.versionNumber) : undefined,
      flavor: isSet(object.flavor) ? globalThis.String(object.flavor) : "",
      variant: isSet(object.variant) ? globalThis.String(object.variant) : "",
    };
  },

  toJSON(message: AppVersion): unknown {
    const obj: any = {};
    if (message.versionNumber !== undefined) {
      obj.versionNumber = AppVersion_VersionNumber.toJSON(message.versionNumber);
    }
    if (message.flavor !== "") {
      obj.flavor = message.flavor;
    }
    if (message.variant !== "") {
      obj.variant = message.variant;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AppVersion>, I>>(base?: I): AppVersion {
    return AppVersion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AppVersion>, I>>(object: I): AppVersion {
    const message = createBaseAppVersion();
    message.versionNumber = (object.versionNumber !== undefined && object.versionNumber !== null)
      ? AppVersion_VersionNumber.fromPartial(object.versionNumber)
      : undefined;
    message.flavor = object.flavor ?? "";
    message.variant = object.variant ?? "";
    return message;
  },
};

function createBaseAppVersion_VersionNumber(): AppVersion_VersionNumber {
  return { major: 0, minor: 0, patch: 0, build: 0 };
}

export const AppVersion_VersionNumber = {
  encode(message: AppVersion_VersionNumber, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.major !== 0) {
      writer.uint32(8).int32(message.major);
    }
    if (message.minor !== 0) {
      writer.uint32(16).int32(message.minor);
    }
    if (message.patch !== 0) {
      writer.uint32(24).int32(message.patch);
    }
    if (message.build !== 0) {
      writer.uint32(32).int32(message.build);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AppVersion_VersionNumber {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppVersion_VersionNumber();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.major = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.minor = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.patch = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.build = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppVersion_VersionNumber {
    return {
      major: isSet(object.major) ? globalThis.Number(object.major) : 0,
      minor: isSet(object.minor) ? globalThis.Number(object.minor) : 0,
      patch: isSet(object.patch) ? globalThis.Number(object.patch) : 0,
      build: isSet(object.build) ? globalThis.Number(object.build) : 0,
    };
  },

  toJSON(message: AppVersion_VersionNumber): unknown {
    const obj: any = {};
    if (message.major !== 0) {
      obj.major = Math.round(message.major);
    }
    if (message.minor !== 0) {
      obj.minor = Math.round(message.minor);
    }
    if (message.patch !== 0) {
      obj.patch = Math.round(message.patch);
    }
    if (message.build !== 0) {
      obj.build = Math.round(message.build);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AppVersion_VersionNumber>, I>>(base?: I): AppVersion_VersionNumber {
    return AppVersion_VersionNumber.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AppVersion_VersionNumber>, I>>(object: I): AppVersion_VersionNumber {
    const message = createBaseAppVersion_VersionNumber();
    message.major = object.major ?? 0;
    message.minor = object.minor ?? 0;
    message.patch = object.patch ?? 0;
    message.build = object.build ?? 0;
    return message;
  },
};

function createBaseMetric(): Metric {
  return { partitionName: "", metricName: "", customDimensions: {}, values: [] };
}

export const Metric = {
  encode(message: Metric, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.partitionName !== "") {
      writer.uint32(10).string(message.partitionName);
    }
    if (message.metricName !== "") {
      writer.uint32(18).string(message.metricName);
    }
    Object.entries(message.customDimensions).forEach(([key, value]) => {
      Metric_CustomDimensionsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).ldelim();
    });
    writer.uint32(34).fork();
    for (const v of message.values) {
      writer.int64(v);
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Metric {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.partitionName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.metricName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          const entry3 = Metric_CustomDimensionsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.customDimensions[entry3.key] = entry3.value;
          }
          continue;
        case 4:
          if (tag === 32) {
            message.values.push(longToNumber(reader.int64() as Long));

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.values.push(longToNumber(reader.int64() as Long));
            }

            continue;
          }

          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Metric {
    return {
      partitionName: isSet(object.partitionName) ? globalThis.String(object.partitionName) : "",
      metricName: isSet(object.metricName) ? globalThis.String(object.metricName) : "",
      customDimensions: isObject(object.customDimensions)
        ? Object.entries(object.customDimensions).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: Metric): unknown {
    const obj: any = {};
    if (message.partitionName !== "") {
      obj.partitionName = message.partitionName;
    }
    if (message.metricName !== "") {
      obj.metricName = message.metricName;
    }
    if (message.customDimensions) {
      const entries = Object.entries(message.customDimensions);
      if (entries.length > 0) {
        obj.customDimensions = {};
        entries.forEach(([k, v]) => {
          obj.customDimensions[k] = v;
        });
      }
    }
    if (message.values?.length) {
      obj.values = message.values.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Metric>, I>>(base?: I): Metric {
    return Metric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Metric>, I>>(object: I): Metric {
    const message = createBaseMetric();
    message.partitionName = object.partitionName ?? "";
    message.metricName = object.metricName ?? "";
    message.customDimensions = Object.entries(object.customDimensions ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseMetric_CustomDimensionsEntry(): Metric_CustomDimensionsEntry {
  return { key: "", value: "" };
}

export const Metric_CustomDimensionsEntry = {
  encode(message: Metric_CustomDimensionsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Metric_CustomDimensionsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetric_CustomDimensionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Metric_CustomDimensionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: Metric_CustomDimensionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Metric_CustomDimensionsEntry>, I>>(base?: I): Metric_CustomDimensionsEntry {
    return Metric_CustomDimensionsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Metric_CustomDimensionsEntry>, I>>(object: I): Metric_CustomDimensionsEntry {
    const message = createBaseMetric_CustomDimensionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseMetricFrame(): MetricFrame {
  return {
    timers: [],
    counters: [],
    levels: [],
    protocolVersion: 0,
    bufferStartTimestampMillis: 0,
    bufferEndTimestampMillis: 0,
    appVersion: undefined,
    clientOsType: 0,
    userId: "",
  };
}

export const MetricFrame = {
  encode(message: MetricFrame, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.timers) {
      Metric.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.counters) {
      Metric.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.levels) {
      Metric.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.protocolVersion !== 0) {
      writer.uint32(32).uint32(message.protocolVersion);
    }
    if (message.bufferStartTimestampMillis !== 0) {
      writer.uint32(40).uint64(message.bufferStartTimestampMillis);
    }
    if (message.bufferEndTimestampMillis !== 0) {
      writer.uint32(48).uint64(message.bufferEndTimestampMillis);
    }
    if (message.appVersion !== undefined) {
      AppVersion.encode(message.appVersion, writer.uint32(58).fork()).ldelim();
    }
    if (message.clientOsType !== 0) {
      writer.uint32(64).int32(message.clientOsType);
    }
    if (message.userId !== "") {
      writer.uint32(74).string(message.userId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MetricFrame {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetricFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timers.push(Metric.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.counters.push(Metric.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.levels.push(Metric.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.protocolVersion = reader.uint32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.bufferStartTimestampMillis = longToNumber(reader.uint64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.bufferEndTimestampMillis = longToNumber(reader.uint64() as Long);
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.appVersion = AppVersion.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.clientOsType = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.userId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetricFrame {
    return {
      timers: globalThis.Array.isArray(object?.timers) ? object.timers.map((e: any) => Metric.fromJSON(e)) : [],
      counters: globalThis.Array.isArray(object?.counters) ? object.counters.map((e: any) => Metric.fromJSON(e)) : [],
      levels: globalThis.Array.isArray(object?.levels) ? object.levels.map((e: any) => Metric.fromJSON(e)) : [],
      protocolVersion: isSet(object.protocolVersion) ? globalThis.Number(object.protocolVersion) : 0,
      bufferStartTimestampMillis: isSet(object.bufferStartTimestampMillis)
        ? globalThis.Number(object.bufferStartTimestampMillis)
        : 0,
      bufferEndTimestampMillis: isSet(object.bufferEndTimestampMillis)
        ? globalThis.Number(object.bufferEndTimestampMillis)
        : 0,
      appVersion: isSet(object.appVersion) ? AppVersion.fromJSON(object.appVersion) : undefined,
      clientOsType: isSet(object.clientOsType) ? osTypeFromJSON(object.clientOsType) : 0,
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
    };
  },

  toJSON(message: MetricFrame): unknown {
    const obj: any = {};
    if (message.timers?.length) {
      obj.timers = message.timers.map((e) => Metric.toJSON(e));
    }
    if (message.counters?.length) {
      obj.counters = message.counters.map((e) => Metric.toJSON(e));
    }
    if (message.levels?.length) {
      obj.levels = message.levels.map((e) => Metric.toJSON(e));
    }
    if (message.protocolVersion !== 0) {
      obj.protocolVersion = Math.round(message.protocolVersion);
    }
    if (message.bufferStartTimestampMillis !== 0) {
      obj.bufferStartTimestampMillis = Math.round(message.bufferStartTimestampMillis);
    }
    if (message.bufferEndTimestampMillis !== 0) {
      obj.bufferEndTimestampMillis = Math.round(message.bufferEndTimestampMillis);
    }
    if (message.appVersion !== undefined) {
      obj.appVersion = AppVersion.toJSON(message.appVersion);
    }
    if (message.clientOsType !== 0) {
      obj.clientOsType = osTypeToJSON(message.clientOsType);
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MetricFrame>, I>>(base?: I): MetricFrame {
    return MetricFrame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MetricFrame>, I>>(object: I): MetricFrame {
    const message = createBaseMetricFrame();
    message.timers = object.timers?.map((e) => Metric.fromPartial(e)) || [];
    message.counters = object.counters?.map((e) => Metric.fromPartial(e)) || [];
    message.levels = object.levels?.map((e) => Metric.fromPartial(e)) || [];
    message.protocolVersion = object.protocolVersion ?? 0;
    message.bufferStartTimestampMillis = object.bufferStartTimestampMillis ?? 0;
    message.bufferEndTimestampMillis = object.bufferEndTimestampMillis ?? 0;
    message.appVersion = (object.appVersion !== undefined && object.appVersion !== null)
      ? AppVersion.fromPartial(object.appVersion)
      : undefined;
    message.clientOsType = object.clientOsType ?? 0;
    message.userId = object.userId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
